export default "__VITE_ASSET__5f447ecb__"